<template>
  <DashboardLayout>

    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <router-link :to="{ name: 'ViewMemo', params: { id: memoId } }"
        class="mb-0 main-identifier fw-semibold text-decoration-none">
        Memo
      </router-link>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Edit Memo</p>
    </div>

    <div class="d-flex justify-content-center">

      <div class="form-outer">
        <form @submit.prevent="handleSubmit">
          <div class="crud-form position-relative">

            <div class="form-inner">
              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">Edit Memo</h1>
              </div>

              <!-- Marquee Notice -->
              <div v-if="form.hasAssociatedPaymentVoucher" class="marquee-wrapper">
                <div class="marquee-content">
                  <p>
                    <span class="material-symbols-outlined">
                      asterisk
                    </span> This memo has an associated Payment Voucher
                  </p>
                  <p>
                    <span class="material-symbols-outlined">
                      asterisk
                    </span>This memo has an associated Payment Voucher
                  </p>
                  <p>
                    <span class="material-symbols-outlined">
                      asterisk
                    </span>This memo has an associated Payment Voucher
                  </p>
                </div>
              </div>

              <div class="form-body">
                <div class="row mt-2 mb-3">
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">File Title</label></div>
                    <div class="col-md-9 input-right">
                      <input id="fileName" type="text" class="form-control form-view-only-input" v-model="currentFileTitle"
                        placeholder="" required disabled />
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">File Number</label></div>
                    <div class="col-md-9 input-right">
                      <input id="fileNumber" type="text" class="form-control form-view-only-input"
                        v-model="currentFileNumber" placeholder="" required disabled />
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Sector</label></div>
                    <div class="col-md-9 input-right">
                      <select class="form-select" v-model="sector" @change="onSectorChange">
                        <option value="" disabled>- Select Sector -</option>
                        <option v-for="sector in sectors" :key="sector.id" :value="sector.id">{{ sector.code }} ({{
                          sector.name }})</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Originating M.D.A.</label></div>
                    <div class="col-md-9 input-right">
                      <select class="form-select" v-model="currentMdaId" @change="onMdaChange" required>
                        <option value="" disabled>- Select MDA -</option>
                        <option v-for="mda in mdas" :key="mda.id" :value="mda.id">{{ mda.name }}</option>
                      </select>
                      <input type="hidden" v-model="currentMdaName">
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Amount Approved (₦)</label></div>
                    <div class="col-md-9 input-right">
                      <input id="amountApproved" type="text" class="form-control"
                        :value="formatCurrency(newAmountApproved)" inputmode="numeric" pattern="[0-9,.]*"
                        @keypress="onlyDigitsAndComma" @input="onAmountApprovedInput"
                        :placeholder="formatCurrency(currentAmountApproved !== null ? currentAmountApproved : '')"
                        required disabled />
                      <!-- <input id="amountApproved" type="text" class="form-control"
                        :value="formatNumber(newAmountApproved)" inputmode="numeric" pattern="[0-9,]*"
                        @keypress="onlyDigitsAndComma" @input="onAmountApprovedInput"
                        :placeholder="formatNumber(currentAmountApproved !== null ? currentAmountApproved : '')"
                        required /> -->
                    </div>
                  </div>

                  <!-- <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Purpose of Request</label></div>
                    <div class="col-md-9 input-right">
                      <div class="col-md-12 input-right">
                        <textarea class="form-control" id="description" v-model="newPurposeRequest"
                          :placeholder="currentPurposeRequest !== null ? currentPurposeRequest : ''" rows="3"
                          required></textarea>
                      </div>
                    </div>
                  </div> -->

                  <div class="col-md-12 row form-group position-relative floating-label-group" v-if="form.remarks">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Remarks:</label></div>
                    <input type="text" class="form-control view-only-input " v-model="form.remarks" placeholder=""
                      readonly>
                  </div>

                </div>
              </div>
            </div>


            <div class="mt-4">
              <div class="d-flex justify-content-center gap-3">

                <button type="submit" class="btn btn-primary submit-btn" :disabled="loading">

                  <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                    aria-hidden="true"></span>

                  {{ (loading ? 'Submitting...' : 'Submit') }}
                </button>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import { useRoute } from 'vue-router';

const mdas = ref([])
const sectors = ref([])
const sector = ref('')
// const mda = ref('')

const root_api_url = process.env.VUE_APP_API_ROOT_URL
const loading = ref(false)
const route = useRoute()
const id = route.params.id

const currentFileTitle = ref('')
const currentFileNumber = ref('')
const currentSector = ref('')
const currentSectorCode = ref('')
const currentMdaId = ref('')
const currentMdaName = ref('')
const currentAmountApproved = ref(0)
// const currentPurposeRequest = ref('')
const currentGroupId = ref('')
const hasAssociatedPaymentVoucher = ref(false)


// Reactive form data
const form = reactive({
  ticketId: '',
  createdDate: '',
  lastModifiedDate: '',
  createdBy: '',
  lastModBy: '',
  userId: '',
  orgCode: '',
  isEditableInd: true,
  memoReturnedInd: false,
  memoRejectedInd: false,
  gHOrGMRemarks: '',
  gHOrGMRemarkDate: '',
  groupTypeId: '',
  fileNumber: '',
  pvMemoId: '',
})

const initialForm = JSON.parse(JSON.stringify(form));

function resetAll() {
  // restore form fields
  Object.assign(form, JSON.parse(JSON.stringify(initialForm)));
}

const newSector = ref('')
const newSectorCode = ref('')
const newMdaId = ref('')
const newMdaName = ref('')
const newAmountApproved = ref(0)
// const newPurposeRequest = ref('')
const newGroupId = ref('')

const fetchMemo = async () => {
  const token = Cookies.get('auth_token');
  try {
    const { data } = await axios.get(`${root_api_url}/appraisal/memo/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const memoData = data
    currentFileTitle.value = memoData.fileTitle || ''
    currentFileNumber.value = memoData.fileNumber || ''
    currentSector.value = memoData.sectorId || ''
    currentSectorCode.value = memoData.sectorCode || ''
    currentMdaId.value = memoData.mdaId || ''
    currentMdaName.value = memoData.originatingMda || ''
    currentAmountApproved.value = memoData.amountApproved ?? null
    // currentPurposeRequest.value = memoData.purposeOfRequest || ''
    currentGroupId.value = memoData.groupTypeId || ''
    form.createdDate = memoData.createdDate;
    form.lastModifiedDate = memoData.lastModifiedDate;
    form.createdBy = memoData.createdBy;
    form.lastModBy = memoData.lastModBy;
    form.userId = memoData.userId;
    form.ticketId = memoData.ticketId;
    form.remarks = memoData.remarks;
    form.orgCode = memoData.orgCode;
    form.isEditableInd = memoData.isEditableInd;
    form.fileNumber = memoData.fileNumber;
    form.groupTypeId = memoData.groupTypeId;
    form.pvMemoId = memoData.pvMemoId;
    hasAssociatedPaymentVoucher.value = memoData.pvMemoId !== null && memoData.pvMemoId !== undefined
    // form.memoReturnedInd = memoData.memoReturnedInd;
    // form.memoRejectedInd = memoData.memoRejectedInd;
    // form.gHOrGMRemarks = memoData.gHOrGMRemarks;
    // form.gHOrGMRemarkDate = memoData.gHOrGMRemarkDate;
    // Clear new values (placeholder approach)
    newSector.value = memoData.sector
    newSectorCode.value = memoData.sectorCode
    newMdaId.value = memoData.mdaId
    newMdaName.value = memoData.originatingMda
    newAmountApproved.value = memoData.amountApproved ?? 0
    // newPurposeRequest.value = memoData.purposeOfRequest || ''
    newGroupId.value = memoData.groupTypeId || ''

  } catch (error) {
    console.error('Error fetching memo:', error);
  }
};

const fetchSectors = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/sector`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    sectors.value = response.data.map(sector => ({
      id: sector.id,
      code: sector.sectorCode,
      name: sector.description,
    }))

  } catch (error) {
    console.error('Failed to fetch sectors:', error)
  }
}

const fetchMDAs = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/mda`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    mdas.value = response.data.map(mda => ({
      id: mda.id,
      name: mda.name,
    }))

  } catch (error) {
    console.error('Failed to fetch mdas:', error)
  }
}

const fetchMDAsFromSector = async (sector_id) => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/mda/all/${sector_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    mdas.value = response.data.map(mda => ({
      id: mda.id,
      name: mda.name,
    }))

  } catch (error) {
    console.error('Failed to fetch roles:', error)
  }
}

const handleSubmit = async () => {
  const token = Cookies.get('auth_token');

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  const sector = newSector.value !== '' ? newSector.value : currentSector.value
  const sectorCode = newSectorCode.value !== '' ? newSectorCode.value : currentSectorCode.value
  const mdaId = newMdaId.value !== '' ? newMdaId.value : currentMdaId.value
  const originatingMda = newMdaName.value !== '' ? newMdaName.value : currentMdaName.value
  const amountApproved = newAmountApproved.value !== '' ? newAmountApproved.value : currentAmountApproved.value
  // const purposeOfRequest = newPurposeRequest.value !== '' ? newPurposeRequest.value : currentPurposeRequest.value
  const groupId = newGroupId.value !== '' ? newGroupId : currentGroupId.value

  const memoData = {
    id: id,
    fileTitle: currentFileTitle.value,
    fileNumber: currentFileNumber.value,
    sector,
    sectorCode,
    mdaId,
    originatingMda,
    amountApproved,
    // purposeOfRequest,
    groupId,
    ticketId: form.ticketId,
    createdDate: form.createdDate,
    lastModifiedDate: form.lastModifiedDate,
    createdBy: form.createdBy,
    lastModBy: form.lastModBy,
    userId: form.userId,
    orgCode: form.orgCode,
    isEditableInd: form.isEditableInd,
    groupTypeId: form.groupTypeId,
    pvMemoId: form.pvMemoId,
    hasAssociatedPaymentVoucher: hasAssociatedPaymentVoucher.value,
  };
  // console.log("Memo data", memoData)

  loading.value = true;

  try {
    await axios.put(`${root_api_url}/appraisal/memo/${id}`, memoData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    // console.log('Memo created successfully:', data);
    Swal.fire({
      html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Memo Updated Successfully</p> `,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    })
    newSector.value = currentSector.value || ''
    newSectorCode.value = currentSectorCode.value || ''
    newMdaId.value = currentMdaId.value || ''
    newMdaName.value = currentMdaName.value || ''
    newAmountApproved.value = currentAmountApproved.value || ''
    // newPurposeRequest.value = currentPurposeRequest.value || ''
    newGroupId.value = currentGroupId.value || ''

    resetAll()

  } catch (error) {
    // console.log('Error updating memo:', err);
    // console.log("Memo data", memoData)

    // Swal.fire({
    //   html: `${iconHtmlError}
    //   <h1 style="font-weight:600;">Error</h1>
    //   <p>Failed to update memo</p>`,
    //   showConfirmButton: true,
    //   showCloseButton: true,
    //   icon: undefined,
    // });

    if (error.response) {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || 'Unexpected error occurred, kindly contact administrator'}</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    } else {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Unexpected error occurred, kindly contact administrator</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    }
  } finally {
    loading.value = false; // Stop loading
  }
}

onMounted(() => {
  fetchMemo()
  if (sector.value) {
    fetchMDAsFromSector(sector.value);
    // console.log("Fetching MDAs for sector", sector.value);
  } else {
    fetchMDAs();
    // console.log("Fetching MDAs", sector.value);
  }
  fetchSectors()
  document.title = "Edit Memo"
})

watch(onSectorChange, () => {
  if (sector.value) {
    currentMdaId.value = ''
    currentMdaName.value = ''
    fetchMDAsFromSector(sector.value);
    // console.log("Fetching MDAs for sector", sector.value);
  }
})

function onSectorChange() {
  // console.log('Sector changed to', sector.value)
  // fetchMdaDetails(mda.value)
  fetchMDAsFromSector(sector.value)
}

function onMdaChange() {
  // console.log('MDA changed to', mda.value)
  const selected = mdas.value.find(item => item.id === currentMdaId.value)
  currentMdaName.value = selected ? selected.name : ''
  newMdaId.value = currentMdaId.value
  newMdaName.value = currentMdaName.value
}

/**
 * Format any number with commas
 */
// function formatNumber(val) {
//   return Number(val || 0).toLocaleString();
// }

function formatCurrency(val) {
  if (val === '' || val === null) return '';
  const num = parseFloat(val).toFixed(2);
  console.log('Formatting number:', num);
  return Number(num).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * Block keys other than digits, comma, or navigation
 */
function onlyDigitsAndComma(e) {
  const k = e.key;
  if (
    (k >= '0' && k <= '9') ||
    k === ',' || k === '.' ||
    ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(k)
  ) return;
  e.preventDefault();
}

/**
 * Handle Amount Approved input
 */
const MAX_SAFE_RAW = Number.MAX_SAFE_INTEGER.toString(); // "9007199254740991"

function onAmountApprovedInput(e) {
  let raw = e.target.value.replace(/\D/g, '');

  if (raw === '') {
    newAmountApproved.value = '';
    e.target.value = '';
    return;
  }

  // Prevent adding more digits than safe
  if (raw.length > MAX_SAFE_RAW.length ||
    (raw.length === MAX_SAFE_RAW.length && raw > MAX_SAFE_RAW)) {
    raw = MAX_SAFE_RAW; // trim to safe max
  }

  const num = parseInt(raw, 10) / 100;
  newAmountApproved.value = Number(num.toFixed(2));
  e.target.value = formatCurrency(newAmountApproved.value);
}

/**
 * Handle the “Amount Approved” input:
 * - strip non‑digits
 * - update the numeric model
 * - re‑format the visible field
 */
// function onAmountApprovedInput(e) {
//   const digits = e.target.value.replace(/[^\d]/g, '');
//   newAmountApproved.value = digits === '' ? 0 : Number(digits);
//   e.target.value = formatNumber(newAmountApproved.value);
// }
</script>

<style scoped>
/* Form Container */
.form-outer {
  width: 100%;
  max-width: 800px;
  /* padding: 1rem; */
}

/* Marquee Styles */
.marquee-wrapper {
  width: 100%;
  overflow: hidden;
  background-color: #f2ffe6;
  padding: 0.5rem 0;
}

.marquee-content {
  display: inline-flex;
  white-space: nowrap;
  animation: marquee 20s linear infinite;
}

.marquee-content span {
  display: inline-block;
  padding: 0 2rem;
  font-size: 1rem;
  font-weight: 500;
  color: #856404;
}

.marquee-content:hover {
  animation-play-state: paused;
}

.view-only-input {
  border: none !important;
  background-color: transparent;
  padding-left: 0;
  cursor: default;
  pointer-events: none;
  color: #212529;
  font-size: 1rem;
  padding-right: 0;
  margin-right: 1rem;
  margin-bottom: 0.5rem !important;
}

.budget-item-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  /* forces every .col to match the tallest */
}

.budget-item-wrapper .view-only-input,
.budget-item-wrapper input.view-only-input {
  flex: 1;
  /* inputs (and your Approval‐Authority <div>) all grow equally */
  /* for your Approval Authority div: */
  white-space: pre-wrap;
}

.dashboard-layout .budget-item-wrapper {
  margin-top: 20px;
  padding: 0 40px;
}

.dashboard-layout .content-wrapper {
  border: 1px solid var(--border);
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  padding: 1rem;
}

.dashboard-layout .section-border {
  /* padding: 1rem; */
  border-top: 3px solid #667eea !important;
}

.dashboard-layout .step-2 {
  padding: 0 20px;
}

.dashboard-layout .budget-item-wrapper.step-2 .col {
  border-right: 1px solid var(--border);
  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05); */
}

.dashboard-layout .budget-item-wrapper.step-2 .col.no-border {
  border-right: none !important;
}

.dashboard-layout .budget-item-wrapper.step-3 .fixed-label {
  min-height: 80px;
  justify-content: flex-start;
  width: 350px;
  box-sizing: border-box;
  text-align: left;
  /* all: unset; */
  display: flex;
  margin-bottom: 0;
  flex-shrink: 0;
  margin-left: 1rem;
}

.dashboard-layout .budget-item-wrapper.step-3 .col {
  padding: 0;
}

.dashboard-layout .budget-item-wrapper.step-3 .content-wrapper {
  border: 1px solid var(--border);
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  /* padding: 1rem; */
}

.dashboard-layout .budget-item-wrapper.step-3 .content {
  border-bottom: 2px solid var(--border);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  gap: 1rem;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.dashboard-layout .budget-item-wrapper.step-3 label {
  font-size: 16px;
  padding: .375rem 0 !important;
  margin-bottom: 0px !important;
  padding-bottom: 0.5rem;
  font-weight: 600;
}

.dashboard-layout .budget-item-wrapper .col-md-3 {
  border: 1px solid #212529;
}

.dashboard-layout .budget-item-wrapper .col-md-3.no-border {
  border: none;
}

.dashboard-layout .budget-item-wrapper .col-md-3.no-border label {
  padding: .375rem .75rem;
  margin-bottom: 0px !important;
}

.dashboard-layout .budget-item-wrapper .col-md-2.no-border {
  border: none;
}

.dashboard-layout .budget-item-wrapper .col-md-2.no-border label {
  padding: .375rem .75rem;
  margin-bottom: 0px !important;
}

.dashboard-layout .fixed-label {
  display: flex;
  align-items: center;
  /* vertical center */
  justify-content: center;
  /* horizontal center */
  min-height: 4rem;
  width: 100%;
  padding: 0 0.25rem;
  box-sizing: border-box;
  text-align: center;
}
</style>
